import { useTranslation } from 'react-i18next';
import { ROUTES } from '@/common/constants/routes';
import { FlowLayout } from '@/common/layouts/FlowLayout/FlowLayout';
import { IIdentificationSlug } from '@/common/types/general';
import { DocumentSlugIdentificationTypeMapping } from '@/common/utils/documents';
import { Redirect, useLocalSearchParams } from 'expo-router';
import { CitizenCardForm } from './CitizenCardForm/CitizenCardForm';
import { TransportationCardForm } from './TransportationCardForm/TransportationCardForm';

export function DocumentFormPage() {
  const { t } = useTranslation();
  const { documentType } = useLocalSearchParams<{
    documentType: IIdentificationSlug;
  }>();

  const documentSlug = DocumentSlugIdentificationTypeMapping[documentType];

  if (!documentSlug) {
    return <Redirect href={ROUTES.PERSONAL_DETAILS} />;
  }

  return (
    <FlowLayout.Root
      headerProps={{
        title: t(`dashboard.document_edit.${documentSlug}.title`),
      }}
    >
      <FlowLayout.Step
        title={t(`dashboard.document_edit.${documentSlug}.step1.title`)}
      >
        {documentType === 'citizen-card' && <CitizenCardForm />}
        {documentType === 'transportation-card' && <TransportationCardForm />}
      </FlowLayout.Step>
    </FlowLayout.Root>
  );
}
